/**
 * Firebase configuration and initialization
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
// export const messaging = getMessaging(app);

export default app;

const VAPID_KEY = "BD3domo2FVLU9b-pv0Qxul2xZyIpKqd1ubaDY204YvjuUJ4mv4psAzBWjA6z9WPHGFTHz_hc_epdWQARtkhBNAc";

const isIOS = () => {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

export const messaging =
  !isIOS() && typeof window !== "undefined" && "serviceWorker" in navigator
    ? getMessaging(app)
    : null;

/**
 * Generate and store FCM token
 */
export const generateToken = async (): Promise<string | null> => {
  try {
    if (
      isIOS() ||
      typeof window === "undefined" ||
      !("Notification" in window) ||
      !("serviceWorker" in navigator) ||
      !messaging
    ) {
      console.log("🚫 Skipping FCM token generation");
      return null;
    }

    const Notif =
      typeof window !== "undefined" && "Notification" in window
        ? window.Notification
        : null;

    if (!Notif) return null;

    const permission = await Notif.requestPermission();

    if (permission !== "granted") return null;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY
    });

    if (token) {
      localStorage.setItem("fcm_token", token);
      return token;
    }

    return null;
  } catch (error) {
    console.error("Error generating FCM token:", error);
    return null;
  }
};


/**
 * Get stored FCM token
 */
export const getFCMToken = (): string | null => {
  return localStorage.getItem('fcm_token');
};

/**
 * Clear FCM token
 */
export const clearFCMToken = (): void => {
  localStorage.removeItem('fcm_token');
};

type QueuedMessage = {
  title: string;
  options: NotificationOptions;
};

const messageQueue: QueuedMessage[] = [];

export function enqueueLocalMessage(title: string, options: NotificationOptions) {
  messageQueue.push({ title, options });
}
export function flushLocalMessages() {
  if (isIOS() || !("Notification" in window)) return;

const Notif =
  typeof window !== "undefined" && "Notification" in window
    ? window.Notification
    : null;

if (!Notif) return;

const status =
  localStorage.getItem("notification_permission") ||
  Notif.permission;

  if (status !== "granted") return;

  while (messageQueue.length) {
    const item = messageQueue.shift()!;
    try {
      new Notif(item.title, item.options);
    } catch { }
  }
}



export function getNotificationPermissionStatus(): string {
  const Notif =
    typeof window !== "undefined" && "Notification" in window
      ? window.Notification
      : null;

  if (isIOS() || !Notif) return "unsupported";

  try {
    return (
      localStorage.getItem("notification_permission") ||
      Notif.permission ||
      "default"
    );
  } catch {
    return "default";
  }
}

